import { render, staticRenderFns } from "./ExpenseDetail.vue?vue&type=template&id=38057266&"
import script from "./expenseDetail.js?vue&type=script&lang=js&"
export * from "./expenseDetail.js?vue&type=script&lang=js&"
import style0 from "./expenseDetail.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports